import script from "./AssessmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentView.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentView.vue?vue&type=style&index=0&id=f2b85a7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b85a7e"]])

export default __exports__